import Badge from '@material-ui/core/Badge';
import { makeStyles } from '@material-ui/core/styles';
import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components/macro';
import { fontSize, media, space } from '../../../theme/tokens';

export const UnreadCount = (props) => {
  const theme = useContext(ThemeContext);
  const classes = makeStyles({
    badge: {
      fontSize: '1.25rem',
      fontWeight: 550,
    },
    colorError: {
      backgroundColor: theme.notification,
    },
  })();
  return <Badge color="error" classes={classes} {...props}></Badge>;
};

export const FullWidthUnreadCount = (props) => {
  const theme = useContext(ThemeContext);
  const classes = makeStyles({
    badge: {
      fontSize: '1.25rem',
      fontWeight: 550,
    },
    colorError: {
      backgroundColor: theme.notification,
    },
    root: {
      width: '100%',
    },
  })();
  return <Badge color="error" classes={classes} {...props}></Badge>;
};

export const StaffCardMargin = styled.li`
  display: flex;
  margin: 0 0 ${space[4]};
  list-style: none;

  ${media.md`
    margin: 0 ${space[4]} ${space[4]} 0;
  `}
`;

export const StudentTargetLi = styled.li`
  font-size: ${fontSize.lg};
  padding: 0;
  list-style: none;
`;

export const StudentTaskLi = styled.div`
  flex: 1;
  min-width: 0;
  font-size: ${fontSize.lg};
`;

export const StaffCardNotification = (props) => {
  return (
    <StaffCardMargin>
      <UnreadCount {...props}></UnreadCount>
    </StaffCardMargin>
  );
};

export const StudentItemNotification = (props) => {
  return (
    <StudentTargetLi>
      <FullWidthUnreadCount {...props}></FullWidthUnreadCount>
    </StudentTargetLi>
  );
};

export const StudentTaskNotification = (props) => {
  return (
    <StudentTaskLi>
      <FullWidthUnreadCount {...props}></FullWidthUnreadCount>
    </StudentTaskLi>
  );
};

const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
`;

// a marker with no count, shown when there is something to check
export const UpdateDot = ({
  show,
  fullWidth,
  label = 'New updates',
  children,
  ...props
}) => {
  const theme = useContext(ThemeContext);
  const classes = makeStyles({
    dot: {
      height: '1.2rem',
      minWidth: '1.2rem',
      borderRadius: '50%',
    },
    colorError: {
      backgroundColor: theme.notification,
    },
    root: fullWidth ? { width: '100%' } : {},
  })();
  return (
    <Badge
      color="error"
      variant="dot"
      invisible={!show}
      classes={classes}
      data-has-updates={!!show}
      {...props}
    >
      {children}
      {show && <VisuallyHidden>{label}</VisuallyHidden>}
    </Badge>
  );
};

export const FullWidthUpdateDot = (props) => <UpdateDot fullWidth {...props} />;

export const StaffCardUpdateDot = (props) => {
  return (
    <StaffCardMargin>
      <UpdateDot {...props} />
    </StaffCardMargin>
  );
};

export const StudentItemUpdateDot = (props) => {
  return (
    <StudentTargetLi>
      <FullWidthUpdateDot {...props} />
    </StudentTargetLi>
  );
};

export const StudentTaskUpdateDot = (props) => {
  return (
    <StudentTaskLi>
      <FullWidthUpdateDot {...props} />
    </StudentTaskLi>
  );
};
